"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnknownPathError = void 0;
class UnknownPathError extends Error {
  constructor(url, validPaths) {
    const pathList = validPaths.join(", ");
    super(`URL path not recognized: "${url}". Valid paths are: ${pathList}`);
    this.url = url;
    this.validPaths = validPaths;
    this.name = "UnknownPathError";
  }
}
exports.UnknownPathError = UnknownPathError;